<template>
    <div>

        <!-- button -->
        <b-button v-b-modal.createCompetition>
            {{ __('configuration.New Competition') }}
        </b-button>

        <!-- create -->
        <b-modal
            id="createCompetition"
            size="md"
            hide-header
            hide-footer>

            <!-- Loading -->
            <b-overlay :show="form.busy">

                <!-- Form -->
                <form @submit.prevent="submit" novalidate="true">

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Name')">
                        <b-form-input
                            v-model="form.name"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                        ></b-form-input>
                        <has-error :form="form" field="name"></has-error>
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group :label="__('configuration.Sport')">
                        <select v-model="form.fk_sport" class="custom-select" :class="{ 'is-invalid': form.errors.has('fk_sport') }">
                            <option v-for="sport in sports" :key="sport.id" :value="sport.id">{{ sport.name }}</option>
                        </select>
                        <has-error :form="form" field="fk_sport"></has-error>
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disabled="form.busy">
                        {{ __('configuration.New Competition') }}
                    </b-button>

                </form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    props: ['locale', 'currency', 'sports'],
    data() {
        return {
            loading: false,
            form: new Form({
                name: null,
                fk_sport: 1,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post('/' + this.locale + '/configurations/competitions')
                .then(result => {
                    this.$bvModal.hide('createCompetition')
                    this.$emit('created')
                    this.$toast.success(result.message)
                    this.form.clear();
                })
        }
    }
}
</script>

<style scoped>

</style>
